import { MoveStruct } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
const Balance = new MoveStruct({
	name: `0x2::balance::Balance<phantom T0>`,
	fields: { value: bcs.u64() }
});
//#endregion
export { Balance };

//# sourceMappingURL=balance.mjs.map